var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled, { css } from 'styled-components';
import { fontSize, space, width } from 'styled-system';
import themeGet from '@styled-system/theme-get';
import { getPaletteColor } from '../utils';
var BaseCSS = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: ", "px 0;\n  color: ", ";\n\n  & > li {\n    margin: ", "px 0;\n  }\n\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  margin: ", "px 0;\n  color: ", ";\n\n  & > li {\n    margin: ", "px 0;\n  }\n\n  ", ";\n  ", ";\n  ", ";\n"])), themeGet('space.1'), getPaletteColor('base'), themeGet('space.1'), fontSize, space, width);
var Ordered = styled('ol')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", ";\n\n  & > li > * {\n    margin-left: ", "px;\n  }\n"], ["\n  ", ";\n\n  & > li > * {\n    margin-left: ", "px;\n  }\n"])), BaseCSS, themeGet('space.2'));
var Unordered = styled('ul')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), BaseCSS);
var List = Unordered;
List.ol = Ordered;
List.ol.displayName = 'OrderedList';
List.ul = Unordered;
List.ul.displayName = 'UnorderedList';
export default List;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=List.js.map